/* AB Maturity Latency isLatencyTest ab_maturity_latency */

import { useState } from 'react';
import { Box, Typography, List, ListItem, IconButton } from '@evaneos/b2b-ui';
import CheckIcon from '@evaneos/b2b-ui/icons/Check';
import KeyboardArrowDownIcon from '@evaneos/b2b-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@evaneos/b2b-ui/icons/KeyboardArrowUp';
import cx from 'classnames';

import { FormattedMessage } from 'react-intl';

import { DossierId } from '../../../../resources/dossier/types';

import s from './ABMatLatency_SuggestionPanel.css';

interface ABMatLatency_SuggestionPanelProps {
    dossierId: DossierId;
}

export const ABMatLatency_SuggestionPanel: React.FC<ABMatLatency_SuggestionPanelProps> = ({
    dossierId: _dossierId, // Prefixed with _ because it will be used for Amplitude tracking later
}) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const handleToggle = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <Box className={cx(s.suggestionPanel, { [s.collapsed]: !isExpanded })}>
            <Box className={s.header} onClick={handleToggle}>
                <Typography variant="h6" color="white" fontWeight="bold">
                    <FormattedMessage id="ab_maturity_latency.discussion.suggestion_panel.title" />
                </Typography>
                <IconButton size="small" className={s.toggleButton}>
                    {isExpanded ? (
                        <KeyboardArrowDownIcon sx={{ color: 'white' }} />
                    ) : (
                        <KeyboardArrowUpIcon sx={{ color: 'white' }} />
                    )}
                </IconButton>
            </Box>

            <Box className={cx(s.separator, { [s.collapsed]: !isExpanded })} />

            <Box className={cx(s.content, { [s.collapsed]: !isExpanded })}>
                <List dense>
                    <ListItem sx={{ p: 0, alignItems: 'flex-start' }}>
                        <CheckIcon sx={{ fontSize: '16px', color: '#C6FF00', mr: 1, mt: 0.5 }} />
                        <Typography variant="body2" color="white">
                            <FormattedMessage id="ab_maturity_latency.discussion.suggestion_panel.advice_traveler_answerd" />
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ p: 0, alignItems: 'flex-start' }}>
                        <CheckIcon sx={{ fontSize: '16px', color: '#C6FF00', mr: 1, mt: 0.5 }} />
                        <Typography variant="body2" color="white">
                            <FormattedMessage
                                id="ab_maturity_latency.discussion.suggestion_panel.advice_no_intro"
                                values={{ b: (chunks) => <span className={s.bold}>{chunks}</span> }}
                            />
                        </Typography>
                    </ListItem>
                    <ListItem sx={{ p: 0, alignItems: 'flex-start' }}>
                        <CheckIcon sx={{ fontSize: '16px', color: '#C6FF00', mr: 1, mt: 0.5 }} />
                        <Typography variant="body2" color="white">
                            <FormattedMessage id="ab_maturity_latency.discussion.suggestion_panel.advice_confirm" />
                        </Typography>
                    </ListItem>
                </List>
            </Box>
        </Box>
    );
};
